import { useNavigate } from 'react-router-dom';

type SidebarItem = {
  id: string;
  label: string;
  icon: string;
  href?: string;
};

const sportsSidebarItems: SidebarItem[] = [
  {
    id: 'inplay',
    label: 'In-Play',
    icon: 'icon-inplay_B',
  },
  {
    id: 'today',
    label: 'Today',
    icon: 'icon-Today',
  },
  {
    id: 'tomorrow',
    label: 'Tomorrow',
    icon: 'icon-Tomorrow',
  },
  {
    id: 'leagues',
    label: 'Leagues',
    icon: 'icon-trophy',
    href: '/leagues',
  },
  {
    id: 'parlay',
    label: 'Parlay',
    icon: 'icon-parlay',
    href: '#',
  },
];

const casinoSidebarItems: SidebarItem[] = [
  {
    id: 'CATALOG',
    label: 'Catalog',
    icon: 'icon-catalog',
  },
  {
    id: 'LATEST',
    label: 'Latest',
    icon: 'icon-latest',
  },
  {
    id: 'A_Z',
    label: 'A-Z',
    icon: 'icon-A-Z',
  },
];

interface SportsSidebarProps {
  activeTab: string;
  variant?: 'sports' | 'casino';
  onTabChange: (tab: string) => void;
}

export default function SportsSidebar({
  activeTab,
  variant = 'sports',
  onTabChange,
}: SportsSidebarProps) {
  const navigate = useNavigate();
  const sidebarItems = variant === 'casino' ? casinoSidebarItems : sportsSidebarItems;

  return (
    <aside className="rounded-xl bg-white p-1 h-max">
      <div className="flex flex-col gap-2">
        {sidebarItems.map((item) => {
          const active = activeTab === item.id;

          return (
            <button
              key={item.id}
              onClick={() => {
                if (item.href) {
                  navigate(item.href);
                } else onTabChange(item.id);
              }}
              className={`flex h-[5.2rem] flex-col items-center justify-center rounded-lg transition-all ${
                active ? 'bg-[#ffcb05] text-black' : 'text-[#5f6875] hover:bg-gray-100'
              }`}
            >
              <i
                className={`${item.icon} relative z-10 mb-1 text-[2rem] group-hover:text-primary transition-colors duration-200`}
              />

              <span className="mt-2 text-[0.688rem] font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </aside>
  );
}
